import { FC } from 'react';
import { ProductCardProps } from './ProductCard.types';

export const ProductCard: FC<ProductCardProps> = ({ product, onSelectProduct }) => {
  const isOutOfStock = product.stock === 0;

  const handleClick = () => {
    if (!isOutOfStock) {
      onSelectProduct(product);
    }
  };

  return (
    <div
      onClick={handleClick}
      className={`bg-white border-2 rounded-lg p-1.5 md:p-2 h-[52px] flex items-center justify-center shadow-sm transition-all product-card ${
        isOutOfStock
          ? 'opacity-50 cursor-not-allowed border-gray-300'
          : 'cursor-pointer hover:shadow-lg hover:border-orange-500 active:scale-95'
      }`}
    >
      {/* Información del producto */}
      <h3 className="font-medium text-[11px] md:text-xs text-center line-clamp-3 leading-tight">
        {product.name}
      </h3>

      {isOutOfStock && (
        <div className="absolute top-2 right-2">
          <span className="text-xs text-red-500 bg-red-50 px-2 py-1 rounded">
            Sin stock
          </span>
        </div>
      )}
    </div>
  );
};